import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { Flex } from "../../../../styled-system/jsx";
import { Button } from "../../../components/core/basic/Button";
import { AdvertisementCell } from "../tableCells/AdvertisementCell";
import { createAppColumnHelper, useClientTable } from "../../../components/table/tableFeatures";
import { Table } from "../../../components/table/Table";
import { RT8Pagination } from "../../../components/table/Pagination";
import { type GVAdvertisement } from "../types";
import { Modal } from "../../../components/core/basic/Modal";

type BulkActionFeedback = {
  failedEntities?: GVAdvertisement[];
  resultMessages?: string[];
};

type Props = {
  bulkActionFeedback?: BulkActionFeedback;
  clearBulkActionFeedback: () => void;
  setSelected: (value: number[]) => void;
  showBulkActionFeedbackModal: boolean;
};

const columnHelper = createAppColumnHelper<GVAdvertisement>();

const columns = [
  columnHelper.accessor("ad_name", {
    header: "",
    enableHiding: false,
    enableSorting: false,
    cell: (props) => {
      return (
        <AdvertisementCell ad={props.row.original} className={css({ marginRight: "auto", overflowX: "hidden" })} />
      );
    },
    size: 550,
  }),
];

const BulkActionFeedbackModal = ({
  showBulkActionFeedbackModal,
  bulkActionFeedback,
  setSelected,
  clearBulkActionFeedback,
}: Props) => {
  const { t } = useTranslation(["advertising", "common"]);
  const failedEntityIds = bulkActionFeedback?.failedEntities?.map((entity) => entity.ad_id);

  const table = useClientTable({
    data: bulkActionFeedback?.failedEntities,
    columns,
    initialState: {
      pagination: { pageIndex: 0, pageSize: 5 },
    },
  });

  return (
    <Modal
      title={t(($) => $.advertising["Bulk Action Results"])}
      isOpen={showBulkActionFeedbackModal}
      onOpenChange={() => clearBulkActionFeedback()}
      css={{ width: "60vw" }}
    >
      {bulkActionFeedback?.resultMessages?.map((message, i) => {
        return (
          <p className={css({ padding: "xsmall", textAlign: "center" })} key={i}>
            {message}
          </p>
        );
      })}
      {bulkActionFeedback?.failedEntities?.length ?
        <div className={css({ width: "600px", margin: "auto" })}>
          <Flex justifyContent={"flex-end"}>
            <RT8Pagination className={css({ marginLeft: "auto" })} table={table} canSetPageSize={false} />
          </Flex>
          <Table table={table} />
        </div>
      : null}

      <Flex className={css({ paddingTop: "large" })} gap={"xlarge"} justifyContent={"center"}>
        {failedEntityIds?.length ?
          <Button
            onPress={() => {
              setSelected(failedEntityIds);
              clearBulkActionFeedback();
            }}
          >
            {t(($) => $.advertising["Retry Updates"])}
          </Button>
        : null}
        <Button
          onPress={() => {
            clearBulkActionFeedback();
          }}
        >
          {t(($) => $.common.actions["Continue"])}
        </Button>
      </Flex>
    </Modal>
  );
};

export default BulkActionFeedbackModal;
